import React, { useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Helmet } from "react-helmet-async";
import signInImage from "../../../assets/images/auth/Webvi1.jpeg";
import signupImage from "../../../assets/images/auth/Webvi2.jpeg";
import { Link } from "react-router-dom";
import SignInForm from "./SignInForm";
import WebsiteLogo from "../../../helpers/WebsiteLogo";
import { useEffect } from "react";

const SignIn = () => {
  const initial_state = {
    login_method: "email",
    // customer_type is no longer needed in initial state if the backend detects it,
    // but we keep it empty or default to avoid breaking your SignInForm props.
    customerType: "",
    email: "",
    password: "",
  };

  // We keep the state variables to avoid breaking the logic in SignInForm
  const [formData, setFormData] = useState(initial_state);

  return (
    <React.Fragment>
      <div>
        <div className="main-content">
          <div className="page-content">
            <Helmet>
              <title>Sign In | Webvi Page </title>
            </Helmet>
            <section className="bg-auth">
              <Container>
                <Row className="justify-content-center">
                  <Col lg={12}>
                    <Card className="auth-box">
                      <Row className="g-0">
                        <Col lg={6} className="text-center">
                          <CardBody className="p-4">
                            <Link to="/">
                              <WebsiteLogo height="55" />
                            </Link>
                            <div className="mt-5">
                              {/* Defaulting to one image since tabs are gone */}
                              <img
                                src={signInImage}
                                alt="User Type"
                                className="img-fluid"
                              />
                            </div>
                          </CardBody>
                        </Col>
                        <Col lg={6}>
                          <CardBody className="auth-content p-5 h-100 text-white">
                            <div className="w-100">
                              <div className="text-center mb-4">
                                <h5>Welcome Back !</h5>
                                <p className="text-white-70">
                                  Sign in to continue to your account.
                                </p>
                              </div>

                              {/* Tabs section has been removed to allow auto-detection */}

                              <SignInForm
                                formData={formData}
                                setFormData={setFormData}
                                // initial_state={initial_state}
                              />

                              <div className="mt-4 text-center">
                                <p className="mb-1 text-white-50">
                                  Don't have an account?
                                </p>
                                <div className="d-flex justify-content-center gap-3">
                                  <Link
                                    to="/signup?role=0"
                                    className="fw-medium text-white text-decoration-underline"
                                  >
                                    Sign Up as Candidate
                                  </Link>
                                  <span className="text-white-50">|</span>
                                  <Link
                                    to="/signup?role=1"
                                    className="fw-medium text-white text-decoration-underline"
                                  >
                                    Sign Up as Employer
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </CardBody>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </section>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SignIn;
